var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters w-full mt-4 flex flex-wrap items-center"},[_c('FilterClimateZone'),_c('FilterSourceStudy'),_c('FilterBuildingType'),_c('FilterTypeVintage'),_c('FilterTypeFuel'),_c('FilterCostEffective')],1)}
var staticRenderFns = []

export { render, staticRenderFns }